'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />
/* tslint:disable:no-unused-variable member-ordering */
var API;
(function (API) {
    var Client;
    (function (Client) {
        'use strict';

        var SellTypesApi = function () {
            function SellTypesApi($http, $httpParamSerializer, basePath) {
                _classCallCheck(this, SellTypesApi);

                this.$http = $http;
                this.$httpParamSerializer = $httpParamSerializer;
                this.basePath = '/proxy/oag/gtw_rh';
                this.defaultHeaders = {};
                if (basePath) {
                    this.basePath = basePath;
                }
            }

            _createClass(SellTypesApi, [{
                key: 'extendObj',
                value: function extendObj(objA, objB) {
                    for (var key in objB) {
                        if (objB.hasOwnProperty(key)) {
                            objA[key] = objB[key];
                        }
                    }
                    return objA;
                }
                /**
                 *
                 * Get list of sell type.\n
                 * @param branchCode
                 */

            }, {
                key: 'sellTypesBranchCodeGet',
                value: function sellTypesBranchCodeGet(branchCode, extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/sellTypes/{branchCode}'.replace('{' + 'branchCode' + '}', String(branchCode));
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    // verify required parameter 'branchCode' is set
                    if (!branchCode) {
                        throw new Error('Missing required parameter branchCode when calling sellTypesBranchCodeGet');
                    }
                    var httpRequestParams = {
                        method: 'GET',
                        url: localVarPath,
                        json: true,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
            }]);

            return SellTypesApi;
        }();

        SellTypesApi.$inject = ['$http', '$httpParamSerializer'];
        Client.SellTypesApi = SellTypesApi;
    })(Client = API.Client || (API.Client = {}));
})(API || (API = {}));